/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.service('WebApi', ['$http', '$q', '$timeout', 'CONFIG', function ($http, $q, $timeout, CONFIG) {

        /* http methods */
        var _http = this.http = function(url, data, method) {
            var deferred = $q.defer();
            url = url;
            url += (url.split('?')[1] ? '&' : '?') + 'lang=' + CONFIG.app.lang.code;
            data = data || null;
            method = method || 'get';            
            $http[method](url, data).then(function (response) {
                deferred.resolve(response);
            }, function (e, status) {
                var error = e && e.data ? {
                    message: e.data.message,
                    messageDetail: e.data.messageDetail,
                    status: e.status,
                } : e;
                deferred.reject(error);
            });
            return deferred.promise;
        }

        var _get = this.get = function (url) {
            return _http(CONFIG.api.prefix + url, null, 'get');
        };

        var _post = this.post = function (url, data) {
            return _http(CONFIG.api.prefix + url, data, 'post');
        };

        var _put = this.put = function (url, data) {
            return _http(CONFIG.api.prefix + url, data, 'put');
        };

        var _patch = this.patch = function (url, data) {
            return _http(CONFIG.api.prefix + url, data, 'patch');
        };

        var _delete = this.delete = function (url) {
            return _http(CONFIG.api.prefix + url, null, 'delete');
        };

        var _static = this.static = function (url) {
            return _http(url, null, 'get');
        };

        var _fake = this.fake = function (data) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve({ data: data });
            }, 1000);
            return deferred.promise;
        };

    }]);

}());